import { css } from 'linaria';

export const fencesAdvantagesSectionList = css`
  display: grid;
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--only-tablet) {
    column-gap: 16px;
    row-gap: 24px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 1fr);
    column-gap: 0;
    row-gap: 24px;

    & li {
      display: flex;
      align-items: center;
    }
  }
`;

export const fencesAdvantagesSectionListStylesMap: Record<number, string> = {
  2: css`
    @media (--from-tablet) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (--from-desktop) {
      & li {
        display: flex;

        & p {
          margin-top: 8px;
          margin-left: 16px;
        }
      }
    }
  `,
  3: css`
    @media (--from-tablet) {
      grid-template-columns: repeat(3, 1fr);
    }
  `,
  4: css`
    @media (--from-desktop) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media (--only-tablet) {
      grid-template-columns: repeat(2, 1fr);
    }
  `,
  5: css`
    @media (--from-desktop) {
      grid-template-columns: repeat(5, 1fr);
    }

    @media (--only-tablet) {
      grid-template-columns: repeat(3, 1fr);
    }
  `,
};

export const fencesAdvantagesSectionIcon = css`
  && {
    @media (--only-mobile) {
      width: 40px;
      height: 40px;
    }
  }
`;

export const fencesAdvantagesSectionItemText = css`
  margin-top: 16px;

  @media (--from-desktop) {
    white-space: break-spaces;
  }

  @media (--only-mobile) {
    margin-top: 0;
    margin-left: 12px;
  }
`;
